var render = function render(){var _vm=this,_c=_vm._self._c;return _c('profile-library',{ref:"library",attrs:{"profile":_vm.profile,"is-owner":true,"drawer-only":true,"refresh-external-context":_vm.refreshExternalContext}})
}
var staticRenderFns = []

export { render, staticRenderFns }